import React from "react";
import { useState } from "react";
import LayoutHOC from "../LayoutHOC";
import Input from "../UniversalComponents/InputComponent";
import Select from "../UniversalComponents/SelectComponent";
import CustomerHeaderHoc from "./CustomerHeaderHoc";
import Button from "../UniversalComponents/DefaultButton";

const ShippingLabel = () => {
  const [formData, setFormData] = useState({
    selectedValue: "",
    email: "",
    emailTo: "",
    businessTo: "",
    businessName: "",
    phoneTo: "",
    phone: "",
    shipVia: "",
    ship: "",
    city: "",
    cityTo: "",
    additional: "",
    apartmentNumber: "",
    apartment: "",
    state: "",
    stateTo: "",
    country: "",
    countryTo: "",
    zipCode: "",
    zip: "",
    lIn: "",
    wIn: "",
    hIn: "",
    lBS: "",
    oZ: "",
  });

  const selectOptions = [
    { value: "option1", label: "Option 1" },
    { value: "option2", label: "Option 2" },
    { value: "option3", label: "Option 3" },
  ];
  const optionData = ["Print or Review"];
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const {
    selectedValue,
    email,
    emailTo,
    businessTo,
    businessName,
    phoneTo,
    phone,
    shipVia,
    ship,
    city,
    cityTo,
    additional,
    apartmentNumber,
    apartment,
    state,
    stateTo,
    country,
    countryTo,
    zipCode,
    zip,
    lIn,
    wIn,
    hIn,
    lBS,
    oZ,
  } = formData;
  const handleSaveButtonClick = () => {
    console.log("Save Button clicked!");
  };

  const handleCancelButtonClick = () => {
    console.log("Cancel Button clicked!");
  };
  return (
    <form className="mx-10 ">
      <div className="w-full border p-4 bg-white rounded">
        <div className="">
          <label className="text-14 text-[#434852] font-400">Add Customer</label>
          <div className="w-[22%]">
            <Select
              placeholder={"Choose a option"}
              options={selectOptions}
              name="selectedValue"
              value={selectedValue}
              onChange={handleInputChange}
              style={{ width: "100%", height: "35px", padding: "5px", color: "#AFAFAF", fontSize: "12px" }}
            />
          </div>
          <div className={selectedValue ? "mb-12" : ""}>
            {selectedValue && (
              <>
                <div className="w-full  mt-4 border rounded border-[#D6D3D3] bg-[#F5F5F5] ">
                  <div className="border-b border-[#BECBD3]">
                    <div className=" p-2 px-3">
                      <label className="text-14 text-[#434852] font-400">From</label>
                    </div>
                  </div>
                  <div className="p-2 px-3">
                    <div className="space-x-2 flex  justify-between w-full">
                      <div className="w-full">
                        <label className="text-14 text-[#434852] font-400">Business Name</label>
                        <Input
                          placeholder="Enter business name"
                          name="businessTo"
                          value={businessTo}
                          onChange={handleInputChange}
                          style={{ width: "100%", height: "35px", padding: "5px" }}
                        />
                      </div>
                      <div className="w-full">
                        <label className="text-14 text-[#434852] font-400">Email</label>
                        <Input
                          placeholder="Enter email Address"
                          name="email"
                          value={email}
                          onChange={handleInputChange}
                          style={{ width: "100%", height: "35px", padding: "5px" }}
                        />
                      </div>
                      <div className="w-full">
                        <label className="text-14 text-[#434852] font-400">Phone</label>
                        <Input
                          placeholder="Enter phone number"
                          type="number"
                          name="phoneTo"
                          value={phoneTo}
                          onChange={handleInputChange}
                          style={{ width: "100%", height: "35px", padding: "5px" }}
                        />
                      </div>
                      <div className="w-full">
                        <label className="text-14 text-[#434852] font-400">Shipping Address</label>
                        <Input
                          placeholder="Enter shipping address"
                          name="shipVia"
                          value={shipVia}
                          onChange={handleInputChange}
                          style={{ width: "100%", height: "35px", padding: "5px" }}
                        />
                      </div>
                    </div>
                    <div className="space-x-2 flex  justify-between w-full mt-2">
                      <div className="w-full">
                        <label className="text-14 text-[#434852] font-400">Apartment, building No.</label>
                        <Input
                          placeholder="Enter Details"
                          name="apartmentNumber"
                          value={apartmentNumber}
                          onChange={handleInputChange}
                          style={{ width: "100%", height: "35px", padding: "5px" }}
                        />
                      </div>
                      <div className="w-full">
                        <label className="text-14 text-[#434852] font-400">City</label>
                        <Input
                          placeholder="Enter City"
                          name="city"
                          value={city}
                          onChange={handleInputChange}
                          style={{ width: "100%", height: "35px", padding: "5px" }}
                        />
                      </div>
                      <div className="w-full">
                        <label className="text-14 text-[#434852] font-400">State</label>
                        <Input
                          placeholder="Enter State"
                          name="state"
                          value={state}
                          onChange={handleInputChange}
                          style={{ width: "100%", height: "35px", padding: "5px" }}
                        />
                      </div>
                      <div className="w-full">
                        <label className="text-14 text-[#434852] font-400">Zip Code</label>
                        <Input
                          placeholder="Enter zip code"
                          name="zipCode"
                          type="number"
                          value={zipCode}
                          onChange={handleInputChange}
                          style={{ width: "100%", height: "35px", padding: "5px" }}
                        />
                      </div>
                    </div>
                    <div>
                      <div className="w-[24.5%] mt-2">
                        <label className="text-14 text-[#434852] font-400">Country</label>
                        <Input
                          placeholder="Enter Country"
                          name="country"
                          value={country}
                          onChange={handleInputChange}
                          style={{ width: "100%", height: "35px", padding: "5px" }}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="w-full  mt-4 border rounded border-[#D6D3D3] bg-[#F5F5F5] ">
                  <div className="border-b border-[#BECBD3]">
                    <div className=" p-2 px-3">
                      <label className="text-14 text-[#434852] font-400">To</label>
                    </div>
                  </div>
                  <div className="p-2 px-3">
                    <div className="space-x-2 flex  justify-between w-full">
                      <div className="w-full">
                        <label className="text-14 text-[#434852] font-400">Customer or Business Name</label>
                        <Input
                          placeholder="Enter Customer or business name"
                          name="businessName"
                          value={businessName}
                          onChange={handleInputChange}
                          style={{ width: "100%", height: "35px", padding: "5px" }}
                        />
                      </div>
                      <div className="w-full">
                        <label className="text-14 text-[#434852] font-400">Additional Name</label>
                        <Input
                          placeholder="Enter Additional Name"
                          name="additional"
                          value={additional}
                          onChange={handleInputChange}
                          style={{ width: "100%", height: "35px", padding: "5px" }}
                        />
                      </div>
                      <div className="w-full">
                        <label className="text-14 text-[#434852] font-400">Email</label>
                        <Input
                          placeholder="Enter email Address"
                          name="emailTo"
                          value={emailTo}
                          onChange={handleInputChange}
                          style={{ width: "100%", height: "35px", padding: "5px" }}
                        />
                      </div>
                      <div className="w-full">
                        <label className="text-14 text-[#434852] font-400 ">Phone</label>
                        <Input
                          placeholder="Enter phone number"
                          type="number"
                          name="phone"
                          value={phone}
                          onChange={handleInputChange}
                          style={{ width: "100%", height: "35px", padding: "5px" }}
                        />
                      </div>
                    </div>
                    <div className="space-x-2 flex  justify-between w-full mt-2">
                      <div className="w-full">
                        <label className="text-14 text-[#434852] font-400">Shipping Address</label>
                        <Input
                          placeholder="Enter shipping address"
                          name="ship"
                          value={ship}
                          onChange={handleInputChange}
                          style={{ width: "100%", height: "35px", padding: "5px" }}
                        />
                      </div>
                      <div className="w-full">
                        <label className="text-14 text-[#434852] font-400">Apartment, building No.</label>
                        <Input
                          placeholder="Enter Details"
                          name="apartment"
                          type="number"
                          value={apartment}
                          onChange={handleInputChange}
                          style={{ width: "100%", height: "35px", padding: "5px" }}
                        />
                      </div>
                      <div className="w-full">
                        <label className="text-14 text-[#434852] font-400">City</label>
                        <Input
                          placeholder="Enter City"
                          name="cityTo"
                          value={cityTo}
                          onChange={handleInputChange}
                          style={{ width: "100%", height: "35px", padding: "5px" }}
                        />
                      </div>
                      <div className="w-full">
                        <label className="text-14 text-[#434852] font-400">State</label>
                        <Input
                          placeholder="Enter State"
                          name="stateTo"
                          value={stateTo}
                          onChange={handleInputChange}
                          style={{ width: "100%", height: "35px", padding: "5px" }}
                        />
                      </div>
                    </div>
                    <div className="space-x-2 flex  justify-between w-[50%] mt-2">
                      <div className="w-full">
                        <label className="text-14 text-[#434852] font-400">Zip Code</label>
                        <Input
                          placeholder="Enter zip code"
                          type="number"
                          name="zip"
                          value={zip}
                          onChange={handleInputChange}
                          style={{ width: "100%", height: "35px", padding: "5px" }}
                        />
                      </div>
                      <div className="w-full ">
                        <label className="text-14 text-[#434852] font-400">Country</label>
                        <Input
                          placeholder="Enter Country"
                          name="countryTo"
                          value={countryTo}
                          onChange={handleInputChange}
                          style={{ width: "100%", height: "35px", padding: "5px" }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="w-full  mt-4 border rounded border-[#D6D3D3] bg-[#F5F5F5] ">
                  <div className="border-b border-[#BECBD3]">
                    <div className=" p-2 px-3">
                      <label className="text-14 text-[#434852] font-400">Package Info</label>
                    </div>
                  </div>
                  <div className="p-2 px-3">
                    <div className="space-x-2 flex  justify-between w-full">
                      <div className="w-full">
                        <label className="text-14 text-[#434852] font-400">L (In)</label>
                        <Input
                          showArrows
                          type="number"
                          name="lIn"
                          value={lIn}
                          onChange={handleInputChange}
                          style={{ width: "100%", height: "35px", padding: "5px" }}
                        />
                      </div>
                      <div className="w-full">
                        <label className="text-14 text-[#434852] font-400">W (In)</label>
                        <Input
                          showArrows
                          type="number"
                          name="wIn"
                          value={wIn}
                          onChange={handleInputChange}
                          style={{ width: "100%", height: "35px", padding: "5px" }}
                        />
                      </div>
                      <div className="w-full">
                        <label className="text-14 text-[#434852] font-400">H (In)</label>
                        <Input
                          showArrows
                          type="number"
                          name="hIn"
                          value={hIn}
                          onChange={handleInputChange}
                          style={{ width: "100%", height: "35px", padding: "5px" }}
                        />
                      </div>
                      <div className="w-full">
                        <label className="text-14 text-[#434852] font-400 ">Lbs</label>
                        <Input
                          showArrows
                          type="number"
                          name="lBS"
                          value={lBS}
                          onChange={handleInputChange}
                          style={{ width: "100%", height: "35px", padding: "5px" }}
                        />
                      </div>
                    </div>
                    <div className="space-x-2 flex  justify-between  mt-2">
                      <div className="w-[24.5%]">
                        <label className="text-14 text-[#434852] font-400">Oz</label>
                        <Input
                          showArrows
                          type="number"
                          name="oZ"
                          value={oZ}
                          onChange={handleInputChange}
                          style={{ width: "100%", height: "35px", padding: "5px" }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>

      <div className="flex justify-between py-3 items-center ">
        <div className="">
          <ul className="flex space-x-3  text-[#009CBF] text-12 font-400">
            {optionData.map((option) => (
              <li key={option}>{option}</li>
            ))}
          </ul>
        </div>

        <div className="flex  space-x-2  ">
          <Button type="primary" onClick={handleCancelButtonClick} style={{ color: "#535252", height: "35px" }}>
            CANCEL
          </Button>
          <Button type="secondary" onClick={handleSaveButtonClick} style={{ height: "35px" }}>
            SAVE
          </Button>
        </div>
      </div>
    </form>
  );
};

export default LayoutHOC(CustomerHeaderHoc(ShippingLabel));
